import PropTypes from 'prop-types'
import styled from 'styled-components'
import startCase from 'lodash/startCase'

import colors from 'components/utils/colors'

const StyledTableRow = styled.tr`
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
`

const StyledTableCell = styled.td`
  padding-top: ${props => props.isFirst ? '0' : (props.isInModal ? '32px' : '48px')};
  padding-bottom: 16px;
  font-family: Exo;
  font-size: 20px;
  line-height: 26px;
  color: ${colors.secondary20};
`

const TableFormGroupHeader = ({ fieldGroup, isFirst = true, isInModal }) => {
  if (fieldGroup.groupTitle === '' || !fieldGroup.group) {
    return null
  }

  const title = fieldGroup.groupTitle || startCase(fieldGroup.group)

  // add fake row to show correct row background
  return (
    <>
      <tr>
        <td colSpan='100%' />
      </tr>
      <StyledTableRow>
        <StyledTableCell colSpan='100%' isFirst={isFirst} isInModal={isInModal} data-test='form-group-header'>
          {title}
        </StyledTableCell>
      </StyledTableRow>
    </>
  )
}

TableFormGroupHeader.propTypes = {
  fieldGroup: PropTypes.object.isRequired,
  isFirst: PropTypes.bool,
  isInModal: PropTypes.bool,
}

export default TableFormGroupHeader
